export var INIT = 0;
export var REQUEST = 2;
export var FINISH = 3;



// WEBPACK FOOTER //
// ./src/constants/PasswordRecoveryState.js